import { Modal } from "../Modal";
import { NoWaveSelectedActions } from "./NoWaveSelectedActions";
import { NoWaveSelectedContent } from "./NoWaveSelectedContent";
import { memo } from "react";

export const NoWaveSelected = memo(({ open, onClose, onContinue }) => {
  return (
    <Modal
      open={!!open}
      title={"No waves Selected"}
      onClose={onClose}
      maxWidth={"xs"}
      content={<NoWaveSelectedContent />}
      actions={<NoWaveSelectedActions onContinue={onContinue} />}
    />
  );
});
